import React, { useState } from "react";
import { Eye, EyeOff } from "react-feather";
import api from "../../../api/axios";

const PasswordReset = ({ activeTab, userId, configuration }) => {
  const [formData, setFormData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  
  const [showPasswords, setShowPasswords] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const togglePasswordVisibility = (field) => {
    setShowPasswords({
      ...showPasswords,
      [field]: !showPasswords[field],
    });
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.oldPassword) {
      newErrors.oldPassword = "Old password is required";
    }

    if (!formData.newPassword) {
      newErrors.newPassword = "New password is required";
    } else if (formData.newPassword.length < 6) {
      newErrors.newPassword = "New password must be at least 6 characters";
    } else if (formData.newPassword === formData.oldPassword) {
      newErrors.newPassword = "New password cannot be the same as old password";
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Please confirm your new password";
    } else if (formData.confirmPassword !== formData.newPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    setMessage(null);

    try {
      const { data } = await api.put(
        `auth/change-password`,
        formData
      );

      setMessage({ type: "success", text: data.message });
      setFormData({ oldPassword: "", newPassword: "", confirmPassword: "" });
    } catch (error) {
      setMessage({
        type: "error",
        text: error.response?.data?.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div div className="tab-content profileSection pt-0" style={{paddingTop:"0px"}}>
      <div
        id="password_reset"
        className={`pro-overview tab-pane fade ${
          activeTab === "password_reset" ? "show active" : ""
        }`}
      >
        <div className="row">
          <div className="col-md-12 d-flex">
            <div className="card flex-fill">
              <div className="card-body">
                <h3 className="card-title">Password Reset</h3>

                {message && (
                  <div
                    className={`alert ${
                      message.type === "success"
                        ? "alert-success"
                        : "alert-danger"
                    }`}
                  >
                    {message.text}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="form-group position-relative">
                    <label>Old Password</label>
                    <input
                      type={showPasswords.oldPassword ? "text" : "password"}
                      className={`form-control ${
                        errors.oldPassword ? "is-invalid" : ""
                      }`}
                      name="oldPassword"
                      value={formData.oldPassword}
                      onChange={handleChange}
                      placeholder="Enter old password"
                      disabled={loading}
                    />
                    <span
                      className="position-absolute"
                      style={{
                        right: "10px",
                        top: "34px",
                        cursor: "pointer",
                      }}
                      onClick={() => togglePasswordVisibility("oldPassword")}
                    >
                      {showPasswords.oldPassword ? (
                        <EyeOff size={20} />
                      ) : (
                        <Eye size={20} />
                      )}
                    </span>
                    {errors.oldPassword && (
                      <div className="invalid-feedback">
                        {errors.oldPassword}
                      </div>
                    )}
                  </div>

                  <div className="form-group position-relative mt-3">
                    <label>New Password</label>
                    <input
                      type={showPasswords.newPassword ? "text" : "password"}
                      className={`form-control ${
                        errors.newPassword ? "is-invalid" : ""
                      }`}
                      name="newPassword"
                      value={formData.newPassword}
                      onChange={handleChange}
                      placeholder="Enter new password"
                      disabled={loading}
                    />
                    <span
                      className="position-absolute"
                      style={{
                        right: "10px",
                        top: "34px",
                        cursor: "pointer",
                      }}
                      onClick={() => togglePasswordVisibility("newPassword")}
                    >
                      {showPasswords.newPassword ? (
                        <EyeOff size={20} />
                      ) : (
                        <Eye size={20} />
                      )}
                    </span>
                    {errors.newPassword && (
                      <div className="invalid-feedback">
                        {errors.newPassword}
                      </div>
                    )}
                  </div>

                  <div className="form-group position-relative mt-3">
                    <label>Confirm Password</label>
                    <input
                      type={showPasswords.confirmPassword ? "text" : "password"}
                      className={`form-control ${
                        errors.confirmPassword ? "is-invalid" : ""
                      }`}
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      placeholder="Confirm new password"
                      disabled={loading}
                    />
                    <span
                      className="position-absolute"
                      style={{
                        right: "10px",
                        top: "34px",
                        cursor: "pointer",
                      }}
                      onClick={() => togglePasswordVisibility("confirmPassword")}
                    >
                      {showPasswords.confirmPassword ? (
                        <EyeOff size={20} />
                      ) : (
                        <Eye size={20} />
                      )}
                    </span>
                    {errors.confirmPassword && (
                      <div className="invalid-feedback">
                        {errors.confirmPassword}
                      </div>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary mt-4"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Updating...
                      </>
                    ) : (
                      "Reset Password"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordReset;